import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=5bff7787&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=ts&"
export * from "./Stock.vue?vue&type=script&lang=ts&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=5bff7787&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff7787",
  null
  
)

export default component.exports